var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.site_token != null && _vm.crm_token != null)?_c('div',{staticClass:"company-crm-widget"},[_c('iframe',{staticClass:"iframe-window",attrs:{"src":_vm.$store.state.crm_url +
    'crm/' +
    _vm.site_token +
    '/' +
    _vm.crm_token +
    '/' +
    '?' +
    _vm.query_path,"frameborder":"0"}}),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show_chat),expression:"show_chat"}],staticClass:"floater"},[_c('chat',{attrs:{"stranger":_vm.newChat}})],1)]):_c('div',{staticClass:"loading-widget"},[_c('loading',{staticClass:"loader",attrs:{"height":25,"color":"#1ba5a4","opacity":1,"width":25,"active":_vm.is_loading,"is-full-page":false,"can-cancel":false,"background-color":"#ffffff"},on:{"update:active":function($event){_vm.is_loading=$event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }